import { Component } from '@angular/core';
import { OrderService } from '@accounts/user/services/order.service';
import { OrderModel } from '@core/api';

@Component({
  selector: 'user-archive-deals',
  templateUrl: './user-archive-deals.component.html',
  styleUrls: ['./user-archive-deals.component.scss']
})
export class UserArchiveDealsComponent {

  allowedStatuses = [
    OrderModel.StatusEnum.Rejected,
    OrderModel.StatusEnum.Closed
  ];

  constructor( ) { }

}
